// extracted by mini-css-extract-plugin
export default {"root":"pill_root__ko2PK","icon":"pill_icon__dzlpl","text":"pill_text__NqZPz"};